// extracted by mini-css-extract-plugin
module.exports = {"component":"checkbox-button-component--_45Vp"};